import { css } from '@emotion/core'
import theme from 'Theme'

const {
  colors
} = theme

export default () => css` 
  appearance: none;
  background-color: transparent; 
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: .75rem;
  vertical-align: middle;
  font-weight: bold;
  border-radius: 'initial';
  transition: all 150ms ease-in;   
  color: ${colors.primary};
  transition: background-color 100ms ease-in, color 100ms ease-in;

  &:hover {
    cursor: pointer;
    background-color: transparent;
    
    svg[name="favorite_border"] {
      stroke: ${colors.primary};
      fill: ${colors.primary};
    }
  }

`
